import SimpleSlider from './SimpleSlider';
import './SimpleSlider.scss';

export default SimpleSlider;
